import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { BaseService } from "../base.service";
import { environment } from "src/environments/environment";



@Injectable()
export class TrackingService extends BaseService<any>{
    constructor(public httpClient: HttpClient) {
        super(
            'user',
            httpClient);
    }


    tracking(no: string, opType: string): Observable<any> {
        
        let uri = new URL(environment.baseUrl + `/${opType}/tracking/${no}`);

        return this.httpClient.get<any>(uri.toString(),  { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }


    trackingShipment(shipmentNo: string, operation: string): Observable<any> {
        let uri = new URL(environment.baseUrl + `/${operation}/trackingShipment/${shipmentNo}`);

        return this.httpClient.get<any>(uri.toString(),  { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    searchGoods(no: string, opType: string): Observable<any[]> {
        const uri = new URL(environment.baseUrl + `/${opType}/trackingGoods/${encodeURIComponent(no)}`);
        return this.httpClient.get<any[]>(uri.toString(), {
            withCredentials: false,
            headers: this.httpHeaders()
        });
    }



    


}
